import { useState } from 'react';
import ProductImagesProvider from './hooks/useProductImages';

import { ProductImagesProps } from './@types/ProductImagesProps';
import ProductImagesContainer from './handles/ProductImagesContainer';
import CarouselContainer from './handles/CarouselContainer';
import CarouselGaleryThumbs from './handles/CarouselGaleryThumbs';
import CarouselGaleryCursor from './handles/CarouselGaleryCursor';
import ProductImagesThumb from './handles/ProductImagesThumb';
import ProductImagesGallerySwiperContainer from './handles/ProductImagesGallerySwiperContainer';
import SwiperCore, { Thumbs, Navigation, Pagination } from 'swiper';

import './swiper.global.css';
import './swiper.scoped.css';
import './override.global.css';
import ProductImage from './handles/ProductImage';
import ProductImageTag from './handles/ProductImageTag';
import { useSelector } from 'react-redux';
import { selectMockImages } from '../../../redux/mockImagesSlice';

SwiperCore.use([Thumbs, Navigation, Pagination]);

const ProductImages = (props: ProductImagesProps) => {
	const fallback = '/images/mock-image-pdp.png';
	const imageList = useSelector(selectMockImages);
	const list = imageList?.['product'];
	const [thumbController, setThumbController] = useState<any>();

	return (
		<ProductImagesProvider {...props}>
			<ProductImagesContainer>
				{props.displayMode === 'carousel' && (
					<CarouselContainer>
						{props.thumbnailVisibility !== 'hidden' && props.thumbnailsOrientation === 'vertical' && (
							<CarouselGaleryThumbs>
								<ProductImagesThumb images={list || [fallback]} thumbController={setThumbController} />
							</CarouselGaleryThumbs>
						)}

						<CarouselGaleryCursor>
							<ProductImagesGallerySwiperContainer images={list || [fallback]} thumbController={thumbController} />

							{props.thumbnailsOrientation === 'horizontal' && (
								<CarouselGaleryThumbs>
									<ProductImagesThumb images={list || [fallback]} thumbController={setThumbController} />
								</CarouselGaleryThumbs>
							)}
						</CarouselGaleryCursor>
					</CarouselContainer>
				)}

				{props.displayMode === 'list' && (
					<>
						{(list || [fallback])?.map((img: any, index: any) => (
							<ProductImage key={`productimg-${index}`}>
								<ProductImageTag src={img} />
							</ProductImage>
						))}
					</>
				)}

				{props.displayMode === 'first-image' && (
					<ProductImage>
						<ProductImageTag src={list[0] ?? fallback} />
					</ProductImage>
				)}
			</ProductImagesContainer>
		</ProductImagesProvider>
	);
};

export default ProductImages;
